module.exports = __webpack_public_path__ + "img/11069852_L.9892594c.png";